export const OCCUPANCY_TYPES = {
  BOYS: 'boys',
  GIRLS: 'girls',
  CO_LIVING: 'co_living',
};

export const OCCUPANCY_GENDER_FILTER_OPTIONS = [
  { value: '', label: 'All' },
  { value: OCCUPANCY_TYPES.BOYS, label: 'Boys' },
  { value: OCCUPANCY_TYPES.GIRLS, label: 'Girls' },
];

export const OCCUPANCY_TYPE_OPTIONS = [
  { value: OCCUPANCY_TYPES.BOYS, label: 'Boys' },
  { value: OCCUPANCY_TYPES.GIRLS, label: 'Girls' },
  { value: OCCUPANCY_TYPES.CO_LIVING, label: 'Co-Living' },
];

export const BUILDING_OCCUPANCY_TYPE_FILTER_OPTIONS = [
  { value: '', label: 'All' },
  ...OCCUPANCY_TYPE_OPTIONS,
];

export const ROOM_GENDER_OPTIONS = [
  { value: OCCUPANCY_TYPES.BOYS, label: 'Boys' },
  { value: OCCUPANCY_TYPES.GIRLS, label: 'Girls' },
];

export const formatOccupancyType = (value) => {
  const normalized = normalizeOccupancyType(value);
  const option = OCCUPANCY_TYPE_OPTIONS.find((item) => item.value === normalized);
  return option ? option.label : '-';
};

export const normalizeOccupancyType = (value) => {
  if (!value) return null;
  const normalized = String(value).trim().toLowerCase();
  if (normalized === OCCUPANCY_TYPES.BOYS || normalized === 'boy') return OCCUPANCY_TYPES.BOYS;
  if (normalized === OCCUPANCY_TYPES.GIRLS || normalized === 'girl') return OCCUPANCY_TYPES.GIRLS;
  if (
    normalized === OCCUPANCY_TYPES.CO_LIVING ||
    normalized === 'co-living' ||
    normalized === 'coliving'
  ) {
    return OCCUPANCY_TYPES.CO_LIVING;
  }
  return normalized;
};

export const getOccupancyTypeBadgeClassName = (occupancyType) => {
  const normalized = normalizeOccupancyType(occupancyType);
  if (normalized === OCCUPANCY_TYPES.BOYS) return 'rt-occupancy-type-badge rt-occupancy-type-badge-boys';
  if (normalized === OCCUPANCY_TYPES.GIRLS) return 'rt-occupancy-type-badge rt-occupancy-type-badge-girls';
  if (normalized === OCCUPANCY_TYPES.CO_LIVING) return 'rt-occupancy-type-badge rt-occupancy-type-badge-co-living';
  return 'rt-occupancy-type-badge';
};

export const normalizeRoomGender = (gender) => {
  if (!gender) return null;
  const value = String(gender).trim().toLowerCase();
  if (value === OCCUPANCY_TYPES.BOYS || value === 'boy') return OCCUPANCY_TYPES.BOYS;
  if (value === OCCUPANCY_TYPES.GIRLS || value === 'girl') return OCCUPANCY_TYPES.GIRLS;
  return value;
};

export const formatRoomGender = (value) => {
  const normalized = normalizeRoomGender(value);
  const option = ROOM_GENDER_OPTIONS.find((item) => item.value === normalized);
  return option ? option.label : '-';
};

export const getRoomGenderBadgeClassName = (gender) => {
  const normalized = normalizeRoomGender(gender);
  if (normalized === OCCUPANCY_TYPES.BOYS) return 'rt-room-gender-badge rt-room-gender-badge-boys';
  if (normalized === OCCUPANCY_TYPES.GIRLS) return 'rt-room-gender-badge rt-room-gender-badge-girls';
  return 'rt-room-gender-badge';
};
